import { render } from "./UpsellScreen.vue?vue&type=template&id=fd139bfc&scoped=true&ts=true"
import script from "./UpsellScreen.vue?vue&type=script&lang=ts"
export * from "./UpsellScreen.vue?vue&type=script&lang=ts"

import "./UpsellScreen.vue?vue&type=style&index=0&id=fd139bfc&scoped=true&lang=css"

import exportComponent from "/Users/pontustengroth/Desktop/git/shipd/apps/shipd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd139bfc"]])

export default __exports__